<template>
    <Dialog
        :value="showDialog"
        :header-text="$t('Review changes')"
        header_classes="black white--text"
        persistent
        :width="780"
        @close_modal="closeModal"
    >
        <v-container v-if="dataLoaded">
            <v-row no-gutters>
                <v-col cols="12" class="pr-2">
                    {{ isEventTypeCompany(companyId) ? $t("Please review and approve changes to the related events") : $t("Please review and approve changes to the related projects") }}
                </v-col>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        hide-default-header
                        disable-pagination
                        :footer-props="{ disablePagination : true, disableItemsPerPage : true }"
                        hide-default-footer
                        class="table-bottom-line"
                    >
                        <template v-slot:header="{ props: { headers } }">
                            <thead>
                                <tr>
                                    <th style="padding-left: 8px; width: 36px; text-align: left;">
                                        <v-checkbox
                                            v-model="selectAll"
                                            hide-details
                                            class="mt-0 pt-0"
                                            @change="selectAllChange"
                                        />
                                    </th>
                                    <th v-for="(h, i) in headers" :key="i">
                                        <span>{{ h.text }}</span>
                                    </th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot:item="{ item }">
                            <tr>
                                <td style="padding-left: 8px; width: 36px;">
                                    <v-checkbox
                                        v-model="item.selected"
                                        hide-details
                                        class="mt-0 pt-0"
                                        @change="selectedChange"
                                    ></v-checkbox>
                                </td>
                                <td>{{ item.client_name }}</td>
                                <td>{{ item.name }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>

        <template v-if="dataLoaded" slot="footer">
            <v-spacer />
            <v-btn text @click="closeModal">
                {{ $t("Cancel") }}
            </v-btn>
            <v-btn class="primary inverted--text" @click="onConfirm">
                {{ $t("Confirm") }}
            </v-btn>
        </template>
    </Dialog>
</template>

<script>
import Dialog from "../../components/Dialog";
import { ref } from "@vue/composition-api";
import { $t } from "@/i18n";
import ProjectModule from "@/store/modules/project";

export default {
    name: "ClientPlanReviewChildrenDialog",
    components: {
        Dialog
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true
        },
        projects: {
            type: Array,
            required: true
        },
        companyId: {
            type: Number,
            required: true
        }
    },
    setup(props, ctx) {
        const { isEventTypeCompany } = ProjectModule()
        const dataLoaded = ref(false);
        const items = ref([]);
        const selectAll = ref(true);
        const headers = [
            { value: "client", text: $t("Client"), sortable: false },
            { value: "name", text: isEventTypeCompany(props.companyId) ? $t('Event') : $t('Project'), sortable: false }
        ];

        const loadData = () => {
            dataLoaded.value = true;
            items.value = props.projects.map(x => ({
                selected: true,
                id: x.id,
                client_name: x.client_id_disp.name,
                name: x.name
            }));
        }
        const selectAllChange = (sel) => {
            for (let item of items.value) {
                item.selected = sel
            }
        }
        const selectedChange = (sel) => {
            if (items.value.filter(x => x.selected).length === 0)
                selectAll.value = false;
            else if (items.value.filter(x => !x.selected).length === 0)
                selectAll.value = true;
        }
        const onConfirm = () => {
            let projectIdList = items.value.filter(x => x.selected).map(x => x.id);
            ctx.emit("confirm", projectIdList);
        }
        const closeModal = () => {
            ctx.emit("close_modal");
        };

        loadData();

        return {
            dataLoaded,
            headers,
            items,
            selectAll,
            onConfirm,
            closeModal,
            selectedChange,
            selectAllChange,
            isEventTypeCompany
        };
    }
}
</script>
